// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import type { EServicesOrchestratorServicePublicNewPathModelsTripleCheckPatientModel } from './eServicesOrchestratorServicePublicNewPathModelsTripleCheckPatientModel.js';
import type { EServicesOrchestratorServicePublicNewPathModelsTripleCheckPrescriberModel } from './eServicesOrchestratorServicePublicNewPathModelsTripleCheckPrescriberModel.js';
import type { Moment } from 'moment';
import type { IAttributeTypeMap, RequestFile } from '@trialcard/shared';

/**
* @description TripleCheckRequestModel
*/
export class EServicesOrchestratorServicePublicNewPathModelsTripleCheckRequestModel {
    /**
    * @description Gets or sets the days supply.
    */
    'daysSupply'?: string | null;
    /**
    * @description Gets or sets the ndc.
    */
    'ndc'?: string | null;
    'patient'?: EServicesOrchestratorServicePublicNewPathModelsTripleCheckPatientModel | null;
    'prescriber'?: EServicesOrchestratorServicePublicNewPathModelsTripleCheckPrescriberModel | null;
    /**
    * @description Gets or sets the pharmacy ncpdp id.
    */
    'pharmacyNcpDpId'?: string | null;
    /**
    * @description Gets or sets the pharmacy npi.
    */
    'pharmacyNpi'?: string | null;
    /**
    * @description Gets or sets the quantity.
    */
    'quantity'?: string | null;
    /**
    * @description Project
    */
    'project'?: string | null;
    /**
    * @description QuickPath Case Id
    */
    'quickPathCaseId'?: number | null;
    /**
    * @description Client Id 1
    */
    'clientId1'?: string | null;
    /**
    * @description Client Id 2
    */
    'clientId2'?: string | null;

    static readonly discriminator: string | undefined = undefined;

    static readonly additionalProperties = false;

    
    static readonly attributeTypeMap: ReadonlyArray<IAttributeTypeMap<keyof EServicesOrchestratorServicePublicNewPathModelsTripleCheckRequestModel>> = [
        {
            "name":     "daysSupply",
            "baseName": "daysSupply",
            "type":     "string"
        },
        {
            "name":     "ndc",
            "baseName": "ndc",
            "type":     "string"
        },
        {
            "name":     "patient",
            "baseName": "patient",
            "type":     "EServicesOrchestratorServicePublicNewPathModelsTripleCheckPatientModel"
        },
        {
            "name":     "prescriber",
            "baseName": "prescriber",
            "type":     "EServicesOrchestratorServicePublicNewPathModelsTripleCheckPrescriberModel"
        },
        {
            "name":     "pharmacyNcpDpId",
            "baseName": "pharmacyNcpDpId",
            "type":     "string"
        },
        {
            "name":     "pharmacyNpi",
            "baseName": "pharmacyNpi",
            "type":     "string"
        },
        {
            "name":     "quantity",
            "baseName": "quantity",
            "type":     "string"
        },
        {
            "name":     "project",
            "baseName": "project",
            "type":     "string"
        },
        {
            "name":     "quickPathCaseId",
            "baseName": "quickPathCaseId",
            "type":     "number"
        },
        {
            "name":     "clientId1",
            "baseName": "clientId1",
            "type":     "string"
        },
        {
            "name":     "clientId2",
            "baseName": "clientId2",
            "type":     "string"
        },
    ];

    static getAttributeTypeMap() {
        return EServicesOrchestratorServicePublicNewPathModelsTripleCheckRequestModel.attributeTypeMap;
    }
}
